import React from 'react';

const Icon = () => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='10.998'
            height='6'
            viewBox='0 0 10.998 6'
        >
            <path
                fill='inherit'
                d='M.51 0a.5.5 0 01.349.154l4.64 4.64 4.64-4.64a.5.5 0 11.706.706L5.853 5.854a.5.5 0 01-.706 0L.154.861a.5.5 0 01.357-.86z'
            ></path>
        </svg>
    );
};

export default Icon;
